import { toMintAccount } from '../accounts.mjs';
import { toMint } from '../models/Mint.mjs';
import { useOperation } from '../../../types/Operation.mjs';

// -----------------
// Operation
// -----------------

const Key = 'FindMintByAddressOperation';

/**
 * Finds a mint account by its address.
 *
 * ```ts
 * const mint = await metaplex.tokens().findMintByAddress({ address });
 * ```
 *
 * @group Operations
 * @category Constructors
 */
const findMintByAddressOperation = useOperation(Key);

/**
 * @group Operations
 * @category Types
 */

/**
 * @group Operations
 * @category Handlers
 */
const findMintByAddressOperationHandler = {
  handle: async (operation, metaplex, scope) => {
    const {
      commitment
    } = scope;
    const {
      address
    } = operation.input;
    const account = toMintAccount(await metaplex.rpc().getAccount(address, commitment));
    return toMint(account);
  }
};

export { findMintByAddressOperation, findMintByAddressOperationHandler };
//# sourceMappingURL=findMintByAddress.mjs.map
